module.exports = __webpack_public_path__ + "media/images/iconSocialX__accent-3ade4e9976b5e13c2a18adfb07baeac3.png";